import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Menu, Segment } from 'semantic-ui-react';
import RestrictedView from 'shared/RestrictedView';
import { PRODUCT_PERMISSIONS, USER_PERMISSIONS } from 'dyl-components';

const ROUTES = {
    tcr: 'tcr',
    brand: 'brand-registration',
    campaign: 'campaign-registration',
    preferences: 'texting-preferences',
}

const TCR = () => {
    return <>
        <Menu secondary className='PhoneManagement_generalTabs'>
            <RestrictedView type="disabled" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}${ROUTES.tcr}/${ROUTES.brand}`} userPermission={USER_PERMISSIONS.BRAND_REGISTRATION_VIEW }>
                <Menu.Item name='Brand Registration' as={NavLink} to={ROUTES.brand} />
            </RestrictedView>
            <RestrictedView type="disabled" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}${ROUTES.tcr}/${ROUTES.campaign}`} userPermission={USER_PERMISSIONS.CAMPAIGN_REGISTRATION_VIEW }>
                <Menu.Item name='Campaign Registration' as={NavLink} to={ROUTES.campaign} />
            </RestrictedView>
            <RestrictedView type="disabled" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}${ROUTES.tcr}/${ROUTES.preferences}`} userPermission={USER_PERMISSIONS.TEXTING_PREFERENCES_VIEW }>
                <Menu.Item name='Texting Preferences' as={NavLink} to={ROUTES.preferences} />
            </RestrictedView>
        </Menu>
        <Segment basic>
            <Outlet />
        </Segment>
    </>;
}

export default TCR;